import { ComponentChildren, VNode } from 'preact';
import styles from './Link.module.css';
import { SvgIcon } from '../Icon/SvgIcon';
import { SvgName } from '../Icon/SvgRegistry';

interface LinkProps {
  children: ComponentChildren;
  href?: string;
  onClick?: (e: MouseEvent) => void;
  icon?: SvgName | VNode;
  iconPosition?: 'start' | 'end';
  isExternal?: boolean;
}

export function Link({
  children,
  href = '#',
  onClick,
  icon,
  iconPosition = 'end',
  isExternal = false,
}: LinkProps) {
  const resolvedIcon = icon ?? (isExternal ? 'newTab' : undefined);
  const combinedClasses = [
    styles.link,
    resolvedIcon ? styles.iconSpaceBetween : '',
  ]
    .filter(Boolean)
    .join(' ');

  /**
   * If its a string (svg) then find it in the registry
   * If its an image, then render the icon.
   * @returns
   */
  const renderIcon = () => {
    if (!resolvedIcon) return null;

    if (typeof resolvedIcon === 'string') {
      return (
        <SvgIcon
          name={resolvedIcon as SvgName}
          size={24}
          className={styles.icon}
        />
      );
    }

    return <span className={styles.icon}>{resolvedIcon}</span>;
  };

  return (
    <a
      href={href}
      className={combinedClasses}
      onClick={onClick}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
    >
      {iconPosition === 'start' && renderIcon()}
      {children}
      {iconPosition === 'end' && renderIcon()}
    </a>
  );
}
